import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { Avatar } from 'antd';

// icons
import { ReadOutlined } from '@ant-design/icons';
import CustomIcons from 'components/CustomIcons';

function SchoolAvatar({ view, school, width, height, fontSize, className, ...rest }) {
  const childClassNames = classNames('school-photo', view, className);
  const defWidth = width ? width : 65;
  const defHeight = height ? height : 65;
  const defFontSize = fontSize ? fontSize : 16;

  const schoolInitials = school?.name && school?.name.charAt(0),
    schoolDefImage = (
      <span
        style={{
          width: `${defWidth}px`,
          minWidth: `${defWidth}px`,
          height: `${defHeight}px`,
          fontSize: `${defFontSize}px`,
        }}
        className="emptyImage"
      >
        {schoolInitials}
      </span>
    );

  return (
    school && (
      <div className={childClassNames}>
        {school?.image ? (
          <Avatar className="photo" size={defWidth} src={school.image} />
        ) : school?.name ? (
          schoolDefImage
        ) : (
          <Avatar className="photo" size={defWidth} icon={<ReadOutlined />} />
        )}
        {view == 'small' && (<>
          {school?.name && (
            <span className="info-name info-name--small">Toute l'école</span>
          )}
        </>)}
        {view == 'full' && (<>
          {school?.name && (
            <span className="info-name info-name--full">Toute l'école</span>
          )}
        </>)}
      </div>
    )
  );
}

SchoolAvatar.defaultProps = {
  view: 'avatar'
};
SchoolAvatar.propTypes = {
  view: PropTypes.oneOf(['full', 'small', 'avatar']).isRequired,
  school: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default compose(
  memo
)(SchoolAvatar);
